import loadable from '@loadable/component';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import type { NodeViewRendererProps, NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

const PollRenderer: FC<NodeViewRendererProps> = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  const Poll = useMemo(
    () => loadable(() => import(/* webpackChunkName: "ricos_plugin_poll" */ './poll')),
    []
  );
  return (
    <Poll
      key={node.id}
      node={node}
      nodeIndex={nodeIndex}
      NodeViewContainer={NodeViewContainer}
      {...props}
    />
  );
};

const PollLoadable = ({ node, nodeIndex, NodeViewContainer, ...props }: NodeViewRendererProps) => {
  return (
    <PollRenderer
      node={node}
      nodeIndex={nodeIndex}
      NodeViewContainer={NodeViewContainer}
      {...props}
    />
  );
};

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.POLL]: PollLoadable,
};
